import { Box, Label } from '@medely/ui-kit';
import { useW2interestEvent } from '@mp/hooks';
import React from 'react';

export const W2InterestBanner = ({ openDialog }: { openDialog: () => void }) => {
  const { trackW2InterestBannerClick } = useW2interestEvent();

  const handleClick = () => {
    openDialog();
    trackW2InterestBannerClick();
  };

  return (
    <Box onClick={handleClick} pb={2}>
      <Label size="m" color="state.teal.secondary">
        Tell us if you’re interested in W-2 shifts
      </Label>
    </Box>
  );
};
